import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const Root = styled("div")(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

export const MainInfo = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  width: "100%",
  padding: "20px 0",
  flexDirection: "column",
  [theme.breakpoints.up("mobile")]: {
    padding: "60px 0",
    flexDirection: "row",
  },
}));

export const Invite = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("mobile")]: {
    width: 694,
    margin: "0 auto 30px",
  },
  [theme.breakpoints.up("tablet")]: {
    width: 832,
    margin: 0,
  },
}));

export const VideoBorder = styled("div", {
  shouldForwardProp: (prop) => prop !== "inviteTheme",
})(({ inviteTheme }) => ({
  border: `6px solid ${inviteTheme.invitationBorderColor}`,
}));

export const Main = styled("div")(({ theme }) => ({
  padding: "20px 0",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  [theme.breakpoints.up("mobile")]: {
    flexDirection: "column",
    width: 312,
    margin: "0 0 100px 40px",
  },
}));

export const Content = styled("div")(({ theme }) => ({
  marginBottom: 20,
  [theme.breakpoints.up("mobile")]: {
    width: "initial",
    marginBottom: 40,
    marginRight: 0,
  },
}));
